// @tennis-matches/core/utils
// DOM utility functions
// Migrated from src/utils/dom.js
import { __asStr } from './common.js';

export function cssEscape(value) {
  // Moderne Browser: CSS.escape exists
  if (typeof CSS !== "undefined" && typeof CSS.escape === "function") {
    return CSS.escape(String(value));
  }
  // Fallback (good-enough)
  return String(value).replace(/["\\]/g, "\\$&");
}

/**
 * Gets the tournament code from URL (query parameter)
 * Supports both search params and hash-based query strings
 * @returns {string} Tournament code or empty string
 */
export function getUrlCode() {
  if (typeof window === "undefined") return "";
  const search = window.location.search || "";
  const hash = String(window.location.hash || "");
  const hashQuery = hash.split("?")[1] || "";
  const query = search || (hashQuery ? `?${hashQuery}` : "");
  try {
    const sp = new URLSearchParams(query.startsWith("?") ? query : `?${query}`);
    return __asStr(sp.get("code") || "");
  } catch (_) {
    return "";
  }
}
